/* eslint-disable import/no-default-export */
export default {
  tabTitle: 'Surveiller par recruteurs',
  only: 'Uniq',
  filter: {
    selectAll: 'Tout sélectionner',
    reset: 'Réinitialiser',
    apply: 'Appliquer',
    only: 'Seulement',
    location: {
      label: 'Lieux',
      all: 'Tous les lieux',
      search: 'Rechercher un lieu...',
    },
    position: {
      open: 'Postes ouverts',
      closed: 'Postes fermés',
      archived: 'Postes archivés',
    },
    jobs: {
      label: 'emplois',
      all: 'Tous les emplois',
      search: 'Rechercher un emploi...',
    },
    province: {
      label: 'Provinces/États',
      all: 'Toutes les provinces/états',
      search: 'Recherche provinces/États...',
    },
    city: {
      label: 'villes',
      all: 'Toutes les villes',
      search: 'Rechercher une ville...',
    },
    district: {
      label: 'Groupes',
      all: 'Tous les groupes',
      search: 'Rechercher des groupes...',
    },
  },
  recruiterSelect: {
    title: 'Recruteurs',
    total: '{{count}} au total',
    search: 'Rechercher des recruteurs',
    selectAll: 'Sélectionner tous les recruteurs',
    apply: 'Appliquer',
    notFound: 'Aucun recruteur trouvé',
  },
  positions: {
    title: 'Postes par lieu et type',
    tableHeader: {
      location: 'Lieu & Poste',
      province: 'Provinces/États',
      city: 'Ville',
      following: 'Suivi',
      watching: 'Surveillé',
      none: 'Aucun',
      sort: {
        label: 'Trier par :',
        options: {
          Location: 'Lieu',
          Followed: 'Suivi',
          Unfollowed: 'Non suivi',
          Watched: 'Surveillé',
          Unwatched: 'Non surveillé',
        },
      },
    },
    row: {
      stats: {
        following: 'Suivi',
        watching: 'Surveillé',
        none: 'Aucun',
      },
    },
    emptyData: 'Aucune donnée à afficher pour le filtre sélectionné.',
  },
  pagination: {
    show: 'Affichage de',
    info: 'sur {{total}} résultats',
  },
  positionRecruiters: {
    searchPlaceholder: 'Rechercher par recruteurs',
    filter: {
      placeholder: 'Tous les types',
      all: 'Tous les types',
      following: 'Suivi',
      watching: 'Surveillé',
      none: 'Aucun',
    },
    count: {
      following: 'Suivi :',
      watching: 'Surveillé :',
      count: 'Recruteur',
      counts: 'Recruiters',
    },
    actions: {
      followed: 'Suivi',
      watched: 'Surveillé',
      none: 'Aucun',
    },
  },
  bulk: {
    actionButton: 'Assigner des postes en masse',
    actionInProgress: 'Assignation en cours',
    cancelAction: `Quitter l'assignation en masse`,
    progressDialog: {
      header: 'Mise à jour des assignations en cours',
      bodyText1: 'Ce processus peut prendre ',
      bodyText2: 'jusqu’à 24 heures',
      bodyText3: `. Tant que cette mise à jour n'est pas terminée, tu ne pourras pas effectuer de mise à jour`,
      button: 'OK',
    },
    recruiterSelectToastMessage: 'Sélectionne au moins un recruteur',
    positionSelectToastMessage: 'Sélectionne au moins un poste',
    selectionCountInfo: {
      all: 'Tous',
      message: 'poste sélectionné.',
      message_empty: 'Aucun poste sélectionné.',
      message_plural: 'postes sélectionnés.',
      allSelected: 'Tous les {{totalCount} postes filtrés sont sélectionnés.',
      clearSelection: 'Effacer la sélection',
      selectAll: 'Sélectionner les {{totalCount} postes filtrés.',
    },
    selectStatus: {
      placeholder: 'Sélectionner le statut',
      follow: 'Suivre',
      watch: 'Surveiller',
      none: 'Aucun',
    },
    confirmButton: 'Confirmer',
    table: {
      location: 'Emplacement',
      position: 'Poste',
    },
  },
};
